import contentJson from "./content.json";
import type { Content } from "./schema";

export const content =
  // SAFETY: content.json is validated against Content by schema.ts at build time.
  contentJson as Content;
